import { A } from '@mobily/ts-belt';
import { Divider, ModuleHeader } from '@stitch-fix/mode-react';
import { useViewEvent } from '@stitch-fix/event-reporter';
import { OutfitsCarousel } from '../OutfitsCarousel/OutfitsCarousel';
import { useWardrobeParams } from '../../utils/hooks/useWardrobeParams';
import { useGetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables } from '../../utils/hooks/getBoughtItemsOutfits';
import { useBoughtItemsMachine } from '../../utils/machines/boughtItems/context-provider';
import { useWardrobeCopy } from '../../utils/contexts/copy-provider';
const formatQueryVariables = () => {
  const variables: GetBoughtItemsOutfitsQueryVariables = {
    id: 'kept-items',
    numOutfits: 12
  };
  return variables;
};

/**
 * <BoughtItemsOutfits /> renders the outfits carousel on the first page
 * on /bought-items. When there are no outfits or it is not on the first
 * page we do not show the carousel.
 */
export const BoughtItemsOutfits = () => {
  const {
    state
  } = useBoughtItemsMachine();
  const {
    wardrobeParams
  } = useWardrobeParams();
  const {
    copy
  } = useWardrobeCopy();
  const shouldSkipOutfitsQuery = !state.matches('success') || wardrobeParams.page !== 1;
  const {
    data,
    loading,
    error
  } = useGetBoughtItemsOutfitsQuery({
    variables: formatQueryVariables(),
    skip: shouldSkipOutfitsQuery
  });
  const {
    ref,
    EventProvider
  } = useViewEvent({
    schema: 'category_view',
    name: 'carousel',
    category_id: 'kept_items'
  });
  const outfits = data?.client?.outfitCollection.outfits.nodes || [];
  const shouldNotRender = error || shouldSkipOutfitsQuery || !loading && A.isEmpty(outfits);
  if (shouldNotRender) {
    return null;
  }
  return <EventProvider>
      <div ref={loading ? null : ref}>
        <Divider variant="subtle" my={{
        sm: 1.5,
        md: 3
      }} />
        <ModuleHeader mb="default" header={copy.boughtModuleOutfitCarouselHeading} />
        <OutfitsCarousel loading={loading} outfits={outfits} source="saved_items" />
        <Divider variant="subtle" my={{
        sm: 1.5,
        md: 3
      }} />
      </div>
    </EventProvider>;
};